import React from 'react'

var EventFormFieldEmail = React.createClass({
  validateEmail: function() {
    const data = { email: this.refs.email.value }
    $.ajax({
      url: '/events/email_lookup',
      type: 'POST',
      data: data,
      dataType: 'json'
    })
    .done(( data, textStatus, jqXHR ) => {
      swal('Success', 'Thank you, your membership has been validated.', 'success');
      this.props.onValidateEmail(data.member);
    })
    .fail(( jqXHR, textStatus ) => {
      var response = $.parseJSON(jqXHR.responseText);
      return swal({
        title: 'Error',
        text: response.error.message,
        type: 'error'
      })
    });
  },
  render: function() {
    const { onChange, label, name, value, required, validatedMembership } = this.props;
    return(
      <div>
        <div className="form-group">
          <label className="col-lg-2 control-label">{label}{ required ? '*' : undefined }</label>
          <div className="col-lg-8">
            <input type="email" className="form-control" name={name} value={value} onChange={e => onChange({[name] : e.target.value })} ref="email" />
          </div>
          <div className="col-lg-2 hide-admin">
            { validatedMembership ?
              <button type="button" className="btn btn-info btn-gradient" disabled="disabled">Validated!</button> :
              <button type="button" className="btn btn-info btn-gradient" onClick={this.validateEmail}>Validate</button>
          }
          </div>
        </div>
        <div className="form-group hide-admin">
          <div className="col-lg-offset-2 col-lg-10">
            <span className="help-block margin-top-sm"><i className="glyphicons glyphicons-circle_info"></i> OPTIONAL: Please enter your e-mail address to auto-fill the form.</span>
          </div>
        </div>
      </div>
    );
  }
});

export default EventFormFieldEmail;


// WEBPACK FOOTER //
// ./src/components/event_form_field_email.js